
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/legal/video-privacy-policy",
      function () {
        return require("private-next-pages/[locale]/legal/video-privacy-policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/legal/video-privacy-policy"])
      });
    }
  